<div [style.width.%]="100" [style.height.%]="100">
  <app-map *ngIf="deviceLocation" class="full-size"
           [markersLocations]="deviceLocation"
           [mapContainerCss]="'full-size'">
  </app-map>
</div>
